import React from 'react';
interface Question {
  id: number;
  text: string;
  contextNote: string;
  colorClass: string;
  bgColorClass: string;
  pinTop: string;
  pinLeft: string;
  delay: string;
  pulseDelay: string;
}
const questions: Question[] = [{
  id: 1,
  text: 'What does the rating mean?',
  contextNote: 'Relates to: 4.7★ (544) rating',
  colorClass: 'border-rose-500',
  bgColorClass: 'bg-rose-500',
  pinTop: '67%',
  pinLeft: '34%',
  delay: '0.3s',
  pulseDelay: '0.5s'
}, {
  id: 2,
  text: 'But… is it safe at 11PM?',
  contextNote: 'Relates to: Walking alone after dark',
  colorClass: 'border-orange-500',
  bgColorClass: 'bg-orange-500',
  pinTop: '28%',
  pinLeft: '42%',
  delay: '0.4s',
  pulseDelay: '1s'
}, {
  id: 3,
  text: 'Is there a hill on the way there?',
  contextNote: 'Relates to: 🚶 10 min walking distance',
  colorClass: 'border-teal-500',
  bgColorClass: 'bg-teal-500',
  pinTop: '30%',
  pinLeft: '45%',
  delay: '0.5s',
  pulseDelay: '1.5s'
}, {
  id: 4,
  text: 'Where should we meet up before?',
  contextNote: 'Relates to: Street and path conditions',
  colorClass: 'border-violet-500',
  bgColorClass: 'bg-violet-500',
  pinTop: '33%',
  pinLeft: '62%',
  delay: '0.6s',
  pulseDelay: '0.2s'
}, {
  id: 5,
  text: 'Is this area my vibe?',
  contextNote: 'Relates to: Mountain View neighborhood',
  colorClass: 'border-blue-500',
  bgColorClass: 'bg-blue-500',
  pinTop: '36%',
  pinLeft: '62%',
  delay: '0.7s',
  pulseDelay: '0.8s'
}, {
  id: 6,
  text: 'Is it worth the 10 minute walk?',
  contextNote: 'Relates to: 🚶 10 min walking distance',
  colorClass: 'border-emerald-500',
  bgColorClass: 'bg-emerald-500',
  pinTop: '65%',
  pinLeft: '50%',
  delay: '0.8s',
  pulseDelay: '1.2s'
}];
export function AnnotatedScreenSlide() {
  return <section className="slide" style={{
    backgroundColor: '#0d1520'
  }} data-id="element-29">
      <div className="flex flex-row w-full h-full min-h-0" data-id="element-30">
        {/* Left Panel — darker navy with blue left border */}
        <div className="flex flex-col justify-center w-[60%] flex-shrink-0 min-h-0 overflow-hidden" style={{
        backgroundColor: '#0d1520',
        borderLeft: '3px solid #4A90D9',
        padding: 'var(--slide-padding)'
      }} data-id="element-31">
          {/* Blue italic label */}
          <p className="italic font-semibold mb-[clamp(0.5rem,1.5vw,1rem)]" style={{
          color: '#4A90D9',
          fontSize: 'var(--body-size)'
        }} data-id="element-32">
            This is a data problem.
          </p>

          {/* Bold heading */}
          <h1 className="font-black tracking-tight text-white leading-[1.05]" style={{
          fontSize: 'var(--title-size)'
        }} data-id="element-33">
            The experience layer doesn't exist.
          </h1>

          {/* Blue accent underline */}
          <div className="mt-[clamp(0.5rem,1.5vw,1rem)] mb-[clamp(0.75rem,2vw,1.5rem)]" style={{
          width: 'clamp(40px, 5vw, 60px)',
          height: '3px',
          backgroundColor: '#4A90D9'
        }} data-id="element-34" />

          {/* Body paragraph */}
          <p className="text-white/60 leading-relaxed mb-[clamp(0.75rem,2vw,1.5rem)]" style={{
          fontSize: 'var(--body-size)',
          maxWidth: '90%'
        }} data-id="element-35">
            What the map shows vs. what users actually need to know.
            <br data-id="element-36" />
            These are the questions people ask themselves
            <br data-id="element-37" />— but never get answers to.
          </p>

          {/* Annotation Cards */}
          <div className="flex flex-col gap-[clamp(0.25rem,0.8vw,0.5rem)] min-h-0 overflow-hidden" data-id="element-38">
            {questions.map(q => <div key={q.id} className="animate-fade-slide" style={{
            animationDelay: q.delay
          }} data-id="element-39">
                <div className={`
                    rounded-md border-l-[3px] ${q.colorClass}
                    flex items-center gap-[clamp(0.5rem,1vw,0.75rem)]
                    transition-transform hover:translate-x-1 duration-300
                  `} style={{
              backgroundColor: 'rgba(255,255,255,0.05)',
              padding: 'clamp(0.4rem, 1vw, 0.65rem) clamp(0.5rem, 1.2vw, 0.85rem)'
            }} data-id="element-40">
                  {/* Number Badge */}
                  <div className={`flex-shrink-0 rounded-full ${q.bgColorClass} flex items-center justify-center`} style={{
                width: 'clamp(20px, 2.5vw, 26px)',
                height: 'clamp(20px, 2.5vw, 26px)'
              }} data-id="element-41">
                    <span className="text-white font-bold leading-none" style={{
                  fontSize: 'clamp(10px, 1.2vw, 13px)'
                }} data-id="element-42">
                      {q.id}
                    </span>
                  </div>

                  {/* Text */}
                  <div className="min-w-0" data-id="element-43">
                    <p className="text-white/90 font-medium leading-snug truncate" style={{
                  fontSize: 'var(--body-size)'
                }} data-id="element-44">
                      {q.text}
                    </p>
                    <p className="text-white/35 truncate" style={{
                  fontSize: 'var(--small-size)'
                }} data-id="element-45">
                      {q.contextNote}
                    </p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>

        {/* Right Panel — phone screenshot with pins */}
        <div className="flex-1 flex items-center justify-center relative overflow-hidden" style={{
        padding: 'var(--slide-padding)',
        backgroundColor: '#0d1520'
      }} data-id="element-46">
          {/* Phone Image Container */}
          <div className="relative animate-fade-slide" style={{
          height: 'min(72vh, 100%)',
          maxWidth: 'clamp(180px, 28vw, 320px)',
          animationDelay: '0.1s'
        }} data-id="element-47">
            <img src="https://cdn.magicpatterns.com/uploads/8tnGT5q1HiR4QypgNbm5gR/Screenshot_2026-03-19_at_12.06.28_PM.png" alt="Google Maps UI showing charging stations in Mountain View" className="w-full h-full object-contain rounded-[clamp(16px,2.5vw,28px)]" style={{
            boxShadow: '0 15px 40px rgba(0,0,0,0.12), 0 0 0 1px rgba(0,0,0,0.06)'
          }} data-id="element-48" />

            {/* Overlay Pins */}
            {questions.map(q => <div key={`pin-${q.id}`} className="absolute z-20 flex items-center justify-center -translate-x-1/2 -translate-y-1/2" style={{
            top: q.pinTop,
            left: q.pinLeft,
            width: 'clamp(20px, 3vw, 28px)',
            height: 'clamp(20px, 3vw, 28px)'
          }} data-id="element-49">
                {/* Pulsing Ring */}
                <div className={`absolute inset-0 rounded-full ${q.bgColorClass} pin-pulse`} style={{
              animationDelay: q.pulseDelay
            }} data-id="element-50" />
                {/* Solid Pin Center */}
                <div className={`relative w-full h-full rounded-full ${q.bgColorClass} flex items-center justify-center shadow-lg border-2 border-white/30`} data-id="element-51">
                  <span className="text-white font-bold leading-none" style={{
                fontSize: 'clamp(10px, 1.5vw, 14px)'
              }} data-id="element-52">
                    {q.id}
                  </span>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}